import t from 'react-translate';
import Avatar from 'athena/components/mentoring-program/avatar';
import { CellProps } from './types';


const NameCell = ({ cell, className }: CellProps) => {
  const user = cell.getValue();

  return (
    <div className={`d-flex align-items-center ${className}`}>
      <Avatar user={user} className='mr-2' />
      <div className='d-flex flex-column justify-content-center align-items-stretch'>
        <div className='text-medium bold ellipsis'>
          {t.USERS.FULL_NAME(user.firstName, user.lastName)}
        </div>
        <div className='text-small color-dark-gray three-line-ellipsis'>
          {user.email}
        </div>
      </div>
    </div>
  );
};

export default NameCell;
